module.exports = __webpack_public_path__ + "static/img/2.4e0ca31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/draw/2.png
// module id = W/QT
// module chunks = 1